module.exports = __webpack_public_path__ + "img/asset9.d374e5fe.png";